import { Skeleton } from '@/components/shadcn/skeleton'
import { TableBody, TableCell, TableRow } from '@/components/shadcn/table'

export function DataTableLoading() {
  return (
    <div className="space-y-4 py-3">
      {/* Table header skeleton */}
      {/* <div className="flex items-center justify-between">
        <Skeleton className="h-8 w-[250px]" />
        <Skeleton className="h-8 w-[180px]" />
      </div> */}

      {/* Search and filter skeleton */}
      <div className="flex items-center justify-between px-2">
        <Skeleton className="h-10 w-[200px]" />
        <div className="flex space-x-2">
          <Skeleton className="h-10 w-[100px]" />
          <Skeleton className="h-10 w-[100px]" />
        </div>
      </div>

      {/* Table skeleton */}
      <div className="w-full rounded-md border">
        {/* Table header */}
        <div className="flex items-center gap-x-2 border-b bg-gray-50 p-4">
          <Skeleton className="mr-4 h-5 flex-1" /> {/* Checkbox */}
          <Skeleton className="mr-4 h-5 flex-1" />
          <Skeleton className="mr-4 h-5 flex-1" />
          <Skeleton className="mr-4 h-5 flex-1" />
          <Skeleton className="h-5 flex-1" />
        </div>

        {/* Table rows */}
        {Array.from({ length: 10 }).map((_, index) => (
          <div key={index} className="flex w-full items-center gap-x-2 border-b p-4">
            <Skeleton className="mr-4 h-4 flex-1" /> {/* Checkbox */}
            <Skeleton className="mr-4 h-4 flex-1" />
            <Skeleton className="mr-4 h-4 flex-1" />
            <Skeleton className="mr-4 h-4 flex-1" />
            <Skeleton className="h-4 flex-1" />
          </div>
        ))}
      </div>
    </div>
  )
}

export function TableBodySkeleton({ nrOfColumns }: { nrOfColumns: number }) {
  return (
    <TableBody>
      {Array.from({ length: 10 }).map((_, index) => (
        <TableRowSkeleton key={index} nrOfColumns={nrOfColumns} />
      ))}
    </TableBody>
  )
}

export function TableRowSkeleton({ nrOfColumns }: { nrOfColumns: number }) {
  return (
    <TableRow>
      {Array.from({ length: nrOfColumns }).map((_, index) => (
        <TableCell key={index}>
          <Skeleton className="h-4" />
        </TableCell>
      ))}
    </TableRow>
  )
}
